module.exports = __webpack_public_path__ + "static/media/shannon-wall-2.d156db89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/developer/gallery/shannon-wall-2.jpg
// module id = 173
// module chunks = 0